import { ShareCardFormat } from '../ShareCard/shareCardTokens'

/** lowercase, non-alphanumeric runs -> '-', leading/trailing '-' stripped. */
export function slugify(value: string): string {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

/** `YYYY-MM` from an ISO date string, e.g. `2025-10-05` -> `2025-10`. */
function yearMonth(isoDate: string): string {
  return isoDate.slice(0, 7)
}

export interface FilenameParts {
  insightLabel: string
  targetKpiLabel: string
  performanceDateGte: string
  performanceDateLte: string
}

/** `purposely-<insight-slug>-<target-kpi-slug>-<daterange>-<format>.png` */
export function buildFilename(parts: FilenameParts, format: ShareCardFormat): string {
  const daterange = `${yearMonth(parts.performanceDateGte)}_${yearMonth(parts.performanceDateLte)}`
  return [
    'purposely',
    slugify(parts.insightLabel),
    slugify(parts.targetKpiLabel),
    daterange,
    format,
  ].join('-') + '.png'
}
